import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, otpPending, user } = useAuth();

  if (isAuthenticated && !otpPending) {
    if (user && user.role === 'EXAM_CENTER') {
      return <Redirect to="/app/exam-center" />;
    }
    return <Redirect to="/app/dashboard" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
